import { z } from 'zod/v4';
import { CaseStatus } from '../cases/index.js';
import helpers from '../economy/helpers/index.js';
import { AddressSchema, PhoneSchema, TagSchema, validateEmail, validatePhone, } from '../index.js';
import { EBoksRecipientSchema } from '../interactions/eboks.js';
import { Lang } from '../lang/Lang.js';
import { PropertyDataSchema } from '../properties/index.js';
import { SproomReceiverSchema } from '../sproom/index.js';
import { ISINCOURTUPDATESTYPES } from '../tribunal/index.js';
import { OrganizationIdentifierScheme } from './types.js';
export var RKIStates;
(function (RKIStates) {
    RKIStates["REPORTED"] = "REPORTED";
    RKIStates["ERROR"] = "ERROR";
    RKIStates["PUBLISHED"] = "PUBLISHED";
    RKIStates["DELETED"] = "DELETED";
    RKIStates["CONCLUDED"] = "CONCLUDED";
})(RKIStates || (RKIStates = {}));
export var SecondaryEmailType;
(function (SecondaryEmailType) {
    SecondaryEmailType["To"] = "TO";
    SecondaryEmailType["CC"] = "CC";
    SecondaryEmailType["BCC"] = "BCC";
})(SecondaryEmailType || (SecondaryEmailType = {}));
export const NewSecondaryEmailSchema = z.object({
    email: z.string(),
    note: z.string().nullish(),
    enabled: z.boolean(),
    type: z.enum(SecondaryEmailType),
});
export const NewSecondaryPhoneSchema = z.object({
    phone: PhoneSchema,
    note: z.string().nullish(),
    enabled: z.boolean(),
});
export const PersonRegisterStatusSchema = z.enum([
    'ACTIVE',
    'DEAD',
    'ABROAD',
    'DISAPPEARED',
    'HOMELESS',
    'DELETED',
    'UNKNOWN',
]);
export const CompanyRegisterStatusSchema = z.enum([
    'ACTIVE',
    'UNDER_LIQUIDATION',
    'UNDER_RECONSTRUCTION',
    'UNDER_BANKRUPTCY',
    'UNDER_RESUMPTION',
    'DISSOLVED',
    'INACTIVE',
    'SHELF',
    'UNKNOWN',
]);
export var DissolvedStatus;
(function (DissolvedStatus) {
    DissolvedStatus["UnderLiquidation"] = "UNDERLIQUIDATION";
    DissolvedStatus["DissolvedAfterLiquidation"] = "DISSOLVEDAFTERLIQUIDATION";
    DissolvedStatus["InvoluntaryDissolution"] = "INVOLUNTARYDISSOLUTION";
    DissolvedStatus["Dissolved"] = "DISSOLVED";
    DissolvedStatus["Unknown"] = "UNKNOWN";
    DissolvedStatus["Voluntary"] = "VOLUNTARY";
    DissolvedStatus["VoluntaryDeclaration"] = "VOLUNTARY_DECLARATION";
    DissolvedStatus["Forced"] = "FORCED";
    DissolvedStatus["DissolvedAfterDeclaration"] = "DISSOLVED_AFTER_DECLARATION";
    DissolvedStatus["DissolvedAfterMerger"] = "DISSOLVED_AFTER_MERGER";
    DissolvedStatus["DissolvedAfterDemerger"] = "DISSOLVED_AFTER_DEMERGER";
    DissolvedStatus["DissolvedAfterBankruptcy"] = "DISSOLVED_AFTER_BANKRUPTCY";
    DissolvedStatus["Ceased"] = "CEASED";
})(DissolvedStatus || (DissolvedStatus = {}));
export var AlternativeContactType;
(function (AlternativeContactType) {
    AlternativeContactType["Lawyer"] = "LAWYER";
    AlternativeContactType["Proprietorship"] = "PROPRIETORSHIP";
    AlternativeContactType["Guardian"] = "GUARDIAN";
    AlternativeContactType["Owner"] = "OWNER";
    AlternativeContactType["Curator"] = "CURATOR";
    AlternativeContactType["Landlord"] = "LANDLORD";
    AlternativeContactType["FinancialAdvisor"] = "FINANCIALADVISOR";
    AlternativeContactType["TaxAuthority"] = "TAXAUTHORITY";
    AlternativeContactType["PowerOfAttorney"] = "POWEROFATTORNEY";
    AlternativeContactType["Administrator"] = "ADMINISTRATOR";
    AlternativeContactType["Police"] = "POLICE";
    AlternativeContactType["Guarantor"] = "GUARANTOR";
    AlternativeContactType["Other"] = "OTHER";
})(AlternativeContactType || (AlternativeContactType = {}));
export var RelationType;
(function (RelationType) {
    RelationType["Cosmo"] = "COSMO";
    RelationType["CustomerReferenceId"] = "CUSTOMER_REFERENCE_ID";
    RelationType["Email"] = "EMAIL";
    RelationType["CPR"] = "CPR";
    RelationType["CVR"] = "CVR";
    RelationType["NameAddress"] = "NAME_ADDRESS";
})(RelationType || (RelationType = {}));
export const RegistryIdentifierSchema = z.object({
    scheme: z.enum(OrganizationIdentifierScheme),
    value: z.string(),
});
export const NewUserDetailsSchema = z.object({
    //description: z.string().nullish(),
    name: z.string().optional(),
    email: z.string().nullish(),
    // Should use registryIdentifier?
    //cpr: z.string().nullish(),
    //cvr: z.string().nullish(),
    //ean: z.string().nullish(),
    registryIdentifier: RegistryIdentifierSchema.nullish(),
    phone: PhoneSchema.nullish(),
    address: AddressSchema.nullish(),
    birthdate: z.string().nullish(),
    //type: z.enum(AlternativeContactType).nullish(),
    //alternativeContactReferenceId: z.string().nullish(),
    //lang: z.enum(Lang).nullish(),
    //secondaryEmails: z.array(NewSecondaryEmailSchema).nullish(),
    //secondaryPhones: z.array(NewSecondaryPhoneSchema).nullish(),
});
export var CompanyStarCycle;
(function (CompanyStarCycle) {
    CompanyStarCycle["Active"] = "ACTIVE";
    CompanyStarCycle["Inactive"] = "INACTIVE";
    CompanyStarCycle["OperationsCeased"] = "OPERATIONSCEASED";
    CompanyStarCycle["ShelfCompany"] = "SHELFCOMPANY";
})(CompanyStarCycle || (CompanyStarCycle = {}));
export var AKSCPRStatus;
(function (AKSCPRStatus) {
    AKSCPRStatus["Active"] = "AKT";
    AKSCPRStatus["Dead"] = "D\u00D8D";
    AKSCPRStatus["Disappeared"] = "FSV";
    AKSCPRStatus["Greenland"] = "GRL";
    AKSCPRStatus["NoPermanentResidence"] = "UDB";
    AKSCPRStatus["GoneAway"] = "UDR";
    AKSCPRStatus["ForTaxReason"] = "SKT";
    AKSCPRStatus["NotVerified"] = "ICV";
    AKSCPRStatus["NoPermanentResidenceGL"] = "UBG";
    AKSCPRStatus["Deregistered"] = "AFM";
    AKSCPRStatus["Cancelled"] = "ANL";
    AKSCPRStatus["Deleted"] = "SLT";
})(AKSCPRStatus || (AKSCPRStatus = {}));
export var AKSKOBStatus;
(function (AKSKOBStatus) {
    AKSKOBStatus["Active"] = "AKT";
    AKSKOBStatus["Inactive"] = "INA";
    AKSKOBStatus["OperationsCeased"] = "OPH";
    AKSKOBStatus["ShelfCompany"] = "SKU";
})(AKSKOBStatus || (AKSKOBStatus = {}));
export var FoundationCode;
(function (FoundationCode) {
    FoundationCode["betalingsp\u00E5krav1p\u00E5tegning"] = "A";
    FoundationCode["betalingsp\u00E5krav2p\u00E5tegning"] = "B";
    FoundationCode["st\u00E6vning"] = "C";
    FoundationCode["fogedsag"] = "D";
    FoundationCode["dom"] = "E";
    FoundationCode["insolvens"] = "F";
    FoundationCode["konkurs"] = "I";
    FoundationCode["tvangsakkord"] = "K";
    FoundationCode["fogedretsrekv"] = "P";
    FoundationCode["tvangsauktionudl\u00E6g"] = "U";
    FoundationCode["skylderkl\u00E6ring"] = "Y";
    FoundationCode["forlig"] = "Z";
    // Below is barely used and not mapable to DBR
    // retsforlig = 'L',
    // offentliginberetning = 'S',
    // tvangsauktion = 'T',
    // gældssanering = 'W',
    // speciel = 'X',
})(FoundationCode || (FoundationCode = {}));
export var AKSStatus;
(function (AKSStatus) {
    AKSStatus["ENROLLED"] = "ENROLLED";
    AKSStatus["LEAVED"] = "LEAVED";
})(AKSStatus || (AKSStatus = {}));
export var PrivateStarCycle;
(function (PrivateStarCycle) {
    PrivateStarCycle["Active"] = "ACTIVE";
    PrivateStarCycle["Dead"] = "DEAD";
    PrivateStarCycle["Disappeared"] = "DISAPPEARED";
    PrivateStarCycle["GoneAway"] = "GONEAWAY";
    PrivateStarCycle["Homeless"] = "HOMELESS";
    PrivateStarCycle["ForTaxReason"] = "FORTAXREASON";
    PrivateStarCycle["NotVerified"] = "NOTVERIFIED";
})(PrivateStarCycle || (PrivateStarCycle = {}));
export const AKSStageMap = {
    [AKSCPRStatus.Dead]: PrivateStarCycle.Dead,
    [AKSCPRStatus.Disappeared]: PrivateStarCycle.Disappeared,
    [AKSCPRStatus.Greenland]: PrivateStarCycle.GoneAway, //Greenland is considered as "Gone Away"
    [AKSCPRStatus.NoPermanentResidence]: PrivateStarCycle.Homeless,
    [AKSCPRStatus.NoPermanentResidenceGL]: PrivateStarCycle.Homeless,
    [AKSCPRStatus.GoneAway]: PrivateStarCycle.GoneAway,
    [AKSCPRStatus.ForTaxReason]: PrivateStarCycle.ForTaxReason,
    [AKSCPRStatus.NotVerified]: PrivateStarCycle.NotVerified,
    [AKSCPRStatus.Deregistered]: PrivateStarCycle.NotVerified,
    [AKSCPRStatus.Cancelled]: PrivateStarCycle.NotVerified,
    [AKSCPRStatus.Deleted]: PrivateStarCycle.NotVerified,
    [AKSCPRStatus.Active]: PrivateStarCycle.Active || CompanyStarCycle.Active,
    [AKSKOBStatus.Inactive]: CompanyStarCycle.Inactive,
    [AKSKOBStatus.OperationsCeased]: CompanyStarCycle.OperationsCeased,
    [AKSKOBStatus.ShelfCompany]: CompanyStarCycle.ShelfCompany,
};
export const validateNewUserOnCustomer = (customer, newUser, index) => {
    if (!newUser) {
        return [{ type: 'invalid_user', index }];
    }
    if (!newUser?.details) {
        return [{ type: 'invalid_user', index }];
    }
    if (!(newUser.relation &&
        ['debtor', 'alternative-contact'].includes(newUser?.relation))) {
        return [{ type: 'invalid_user', index }];
    }
    if (typeof newUser.contact !== 'boolean') {
        return [{ type: 'invalid_user', index }];
    }
    if (newUser.relation === 'alternative-contact' &&
        !Object.values(AlternativeContactType).includes(newUser.details.type)) {
        return [{ type: 'invalid_user', index }];
    }
    let errors = [];
    const validName = validateName(newUser.details.name || '');
    if (!validName) {
        errors.push({ type: 'invalid_name', index });
    }
    const validPhone = !newUser.details.phone || validatePhone(newUser.details.phone);
    if (!validPhone) {
        errors.push({ type: 'invalid_phone', index });
    }
    const validLocalIdentifier = !customer.isCompany
        ? !newUser.details.cpr || validateCPR(newUser.details.cpr)
        : !newUser.details.cvr || validateCVR(newUser.details.cvr);
    if (!validLocalIdentifier) {
        errors.push({ type: 'invalid_register_id', index });
    }
    const eitherValidEmailOrAddress = !!newUser.details.address || validateEmail(newUser.details.email);
    if (!eitherValidEmailOrAddress) {
        errors.push({ type: 'invalid_email_or_missing_address', index });
    }
    return errors;
};
export const validateNewCustomer = (newCustomer) => {
    let errors = [];
    if (!newCustomer) {
        return [{ type: 'missing_customer' }];
    }
    if (newCustomer.referenceId === null || !newCustomer.referenceId) {
        errors.push({ type: 'missing_ref_id' });
    }
    if (newCustomer.users) {
        for (let i = 0; i < newCustomer.users.length; i++) {
            const user = newCustomer.users[i];
            errors.push(...validateNewUserOnCustomer(newCustomer, user, i));
        }
    }
    return errors;
};
export const NewUserOnCustomerSchema = z.object({
    lang: z.enum(Lang),
    contact: z.boolean(),
    relation: z.enum(['debtor', 'alternative-contact']),
    details: z.any(),
});
export const NewCustomerSchema = z.object({
    properties: z.record(z.string(), PropertyDataSchema).optional(),
    referenceId: z
        .string()
        .trim()
        .nullish()
        .transform((x) => x ?? null),
    defaultCaseGroupId: z
        .uuid()
        .nullish()
        .transform((x) => x ?? null),
    isCompany: z.boolean(),
    users: z
        .array(NewUserOnCustomerSchema)
        .nullish()
        .transform((x) => x ?? undefined),
});
export const UserOnCustomerDetailsSchema = z.object({
    name: z
        .string()
        .transform((val) => (val === '' ? null : val))
        .nullish(),
    email: z
        .string()
        .transform((val) => (val === '' ? null : val))
        .nullish(),
    carRegistrationNumber: z.string().nullish(),
    phone: PhoneSchema.nullish(),
    courtId: z.string().nullish(),
    address: AddressSchema.nullish(),
    birthdate: z.string().nullish(),
    cvr: z
        .string()
        .transform((val) => (val === '' ? null : val))
        .nullish(),
    cpr: z
        .string()
        .transform((val) => (val === '' ? null : val))
        .nullish(),
    ean: z
        .string()
        .transform((val) => (val === '' ? null : val))
        .nullish(),
    description: z.string().nullish(),
    type: z.enum(AlternativeContactType).nullish(),
    alternativeContactReferenceId: z.string().nullish(),
});
export const PatchUserOnCustomerSchema = z.object({
    contact: z.boolean().optional(),
    lang: z.enum(Lang).optional(),
    details: z
        .object({
        name: z.string().optional(),
        email: z
            .string()
            .transform((val) => (val === '' ? null : val))
            .nullish(),
        phone: PhoneSchema.nullish(),
        courtId: z
            .string()
            .transform((val) => (val === '' ? null : val))
            .nullish(),
        address: AddressSchema.nullish(),
        birthdate: z.string().nullish(),
        cvr: z
            .string()
            .transform((val) => (val === '' ? null : val))
            .nullish(),
        cpr: z
            .string()
            .transform((val) => (val === '' ? null : val))
            .nullish(),
        ean: z
            .string()
            .transform((val) => (val === '' ? null : val))
            .nullish(),
        registryIdentifier: z
            .object({
            scheme: z.enum(OrganizationIdentifierScheme),
            value: z.string(),
        })
            .nullish(),
        description: z
            .string()
            .transform((val) => (val === '' ? null : val))
            .nullish(),
        deliverability: z
            .object({
            eboks: z
                .array(z.object({
                recipient: EBoksRecipientSchema,
                success: z.boolean(),
                timestamp: z.string().datetime({ offset: true }),
                manualOverride: z.literal(true).optional(),
            }))
                .optional(),
            eInvoice: z
                .array(z.object({
                recipient: SproomReceiverSchema,
                success: z.boolean(),
                timestamp: z.string().datetime({ offset: true }),
                manualOverride: z.literal(true).optional(),
            }))
                .optional(),
        })
            .optional(),
        type: z.enum(AlternativeContactType).nullish(),
        alternativeContactReferenceId: z.string().nullish(),
    })
        .optional(),
});
export const AddEventSchema = z.object({
    type: z.string(),
    details: z.any().optional(),
});
export const PatchCustomerSchema = z.object({
    referenceId: z
        .string()
        .nullish()
        .transform((x) => x ?? undefined),
    defaultCaseGroupId: z
        .uuid()
        .nullish()
        .transform((x) => x ?? undefined),
    isCompany: z.boolean().optional(),
    tags: z.array(TagSchema).optional(),
});
export const getDebtorsOnCustomer = (customer) => customer.users.filter((user) => user.relation === 'debtor');
export const getContactPerson = (customer, _case) => {
    const user = customer.users.find((user) => user.userOnCustomerId === _case.userOnCustomerId);
    return user || null;
};
export const validateCPR = (cpr) => {
    const pattern = /^$|^\d{6}(-?){1}\d{4}$/;
    return pattern.test(cpr);
};
export const validateCVR = (cvr) => {
    const pattern = /^\d{8}$/;
    return pattern.test(cvr);
};
export const validateName = (name) => {
    const pattern = /^[^ ].{0,100}$/;
    return pattern.test(name);
};
export const defaultMergeRules = {
    caseStatus: [CaseStatus.PENDING, CaseStatus.VERIFIED],
    hasFoundation: false,
    doesNotHaveUpdateTypeIds: ISINCOURTUPDATESTYPES,
    hasActivePaymentPlan: false,
    preventMerge: false,
};
export const CaseMergeRulesSchema = z.object({
    caseStatus: z.array(z.enum(CaseStatus)),
    hasFoundation: z.boolean().nullish(),
    doesNotHaveUpdateTypeIds: z.array(z.uuid()),
    doesHaveUpdateTypeIds: z.array(z.uuid()).optional(),
    hasActivePaymentPlan: z.boolean().nullish(),
    preventMerge: z.boolean().optional(),
    adjustVariableCaseVouchers: z.boolean().optional(),
    caseVoucherConstraints: z
        .array(z.object({
        voucherTypeId: z.uuid(),
        timeConstraintInDays: z.number().optional(),
    }))
        .optional(),
});
// When adding deposits or credit notes to a customer, we need to find a matching voucher/case to add the deposit or credit note to.
export const getMatchForVoucher = (voucher, casesWithCaseVouchers) => {
    const sortEndedLast = (a, b) => (a.status === CaseStatus.ENDED ? 1 : -1) -
        (b.status === CaseStatus.ENDED ? 1 : -1);
    // Match on voucher amount VERIFIED / PENDING / ENDED
    const matchVoucherAmountFn = (v) => Math.round(v.amount / 100) === Math.round(-voucher.amount / 100);
    const matchOnVoucherAmountCase = casesWithCaseVouchers
        .sort(sortEndedLast)
        .find((_case) => -helpers.overview.balance(_case.caseVouchers) >= voucher.amount &&
        _case.caseVouchers.find(matchVoucherAmountFn));
    if (matchOnVoucherAmountCase) {
        const matchingVoucher = matchOnVoucherAmountCase.caseVouchers.find(matchVoucherAmountFn);
        if (matchingVoucher) {
            return {
                caseId: matchOnVoucherAmountCase.caseId,
                caseVoucherId: matchingVoucher.caseVoucherId,
            };
        }
    }
    // Match on balance amount VERIFIED / PENDING / ENDED
    const matchBalanceCase = casesWithCaseVouchers
        .sort(sortEndedLast)
        .find((_case) => Math.abs(helpers.overview.balance(_case.caseVouchers) - voucher.amount) < 2500);
    if (matchBalanceCase) {
        return {
            caseId: matchBalanceCase.caseId,
            caseVoucherId: null,
        };
    }
    // Match where below balance amount VERIFIED / PENDING / ENDED
    const matchBelowBalanceCase = casesWithCaseVouchers
        .sort(sortEndedLast)
        .find((_case) => -helpers.overview.balance(_case.caseVouchers) > voucher.amount);
    if (matchBelowBalanceCase) {
        return {
            caseId: matchBelowBalanceCase.caseId,
            caseVoucherId: null,
        };
    }
    return null;
};
//# sourceMappingURL=index.js.map